import { Shield, Cloud, Cpu, FileCheck, Code2, Activity } from "lucide-react";
import { Reveal } from "@/components/Reveal";

const services = [
  {
    icon: Shield,
    title: "Cybersecurity Assessments",
    desc: "Penetration testing, threat modeling, and red-team exercises that expose real risk before adversaries do.",
    span: "lg:col-span-2",
  },
  {
    icon: Cloud,
    title: "Cloud Consulting",
    desc: "Architect, migrate, and harden cloud estates across AWS, Azure, and GCP.",
    span: "",
  },
  {
    icon: Cpu,
    title: "AI Integration",
    desc: "Deploy AI and automation safely — with governance built in.",
    span: "",
  },
  {
    icon: FileCheck,
    title: "Compliance Consulting",
    desc: "SOC 2, ISO 27001, HIPAA, and GDPR — from gap analysis to audit-ready.",
    span: "",
  },
  {
    icon: Code2,
    title: "Application Security",
    desc: "Secure SDLC, code review, and DevSecOps embedded into your pipeline.",
    span: "",
  },
  {
    icon: Activity,
    title: "Managed Security Services",
    desc: "Ongoing monitoring, detection, and response — delivered as a monthly plan sized to your team.",
    span: "lg:col-span-2",
  },
];

export function Services() {
  return (
    <section id="services" className="bg-black py-24 lg:py-36" data-testid="services">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6 mb-14">
          <Reveal>
            <h2 className="font-display text-3xl sm:text-5xl tracking-tight text-paper max-w-[14ch]">
              Consulting, engineered for outcomes.
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="text-sm text-fog max-w-sm leading-relaxed">
              Eight disciplines, one accountable team. We meet you where you are and
              take you to secure, scalable, and compliant.
            </p>
          </Reveal>
        </div>

        <div className="grid gap-px bg-white/10 border border-white/10 lg:grid-cols-3 rounded-2xl overflow-hidden">
          {services.map((s, i) => (
            <Reveal key={s.title} delay={i * 0.06} className={`${s.span}`}>
              <div
                className="group h-full bg-surface p-8 lg:p-10 hover:bg-[#232326] transition-colors duration-500"
                data-testid={`service-card-${i}`}
              >
                <s.icon size={22} className="text-paper mb-8" strokeWidth={1.4} />
                <h3 className="font-display text-xl lg:text-2xl tracking-tight text-paper mb-3">
                  {s.title}
                </h3>
                <p className="text-sm text-fog leading-relaxed max-w-md">{s.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
